import React, { useContext } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import localeContext from '../localeContext';

const Link = ({ to, ...props }) => {
  const { locale } = useContext(localeContext);

  const path = to === '/' ? '' : to;
  const localizedPath = locale.default ? to : `/${locale.path}${path}`;

  return <GatsbyLink {...props} to={localizedPath} />;
};

export default Link;
